<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Edit Region - District</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                          :class="{ card: !isSubPage }"
                        >
                          <!--[form-content-start]-->
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Region *</div>
                              <div id="ctrl-region-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('region')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlregion"
                                  v-model="formData.region"
                                  :options="app.menus.gwclRegionItems"
                                  label="Region"
                                  placeholder="Select ..."
                                  :filter="true"
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('region')"
                                  class="p-error"
                                  >{{ getFieldError("region") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                District *
                              </div>
                              <div id="ctrl-district-holder">
                                <InputText
                                  ref="ctrldistrict"
                                  v-model.trim="formData.district"
                                  pattern="^[A-Za-z0-9-', ]+$"
                                  label="District"
                                  type="text"
                                  placeholder="Enter District"
                                  class="w-full"
                                  :class="getErrorClass('district')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('district')"
                                  class="p-error"
                                  >{{ getFieldError("district") }}</small
                                >
                              </div>
                            </div>
                          </div>
                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update"
                              class=" p-button-rounded"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "region_districts",
  },
  routeName: {
    type: String,
    default: "region_districtsedit",
  },
  pagePath: {
    type: String,
    default: "region_districts/edit",
  },
  apiPath: {
    type: String,
    default: "region_districts/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default: "Record updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    region: "",
    district: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  if (props.redirect) app.navigateTo(`/region_districts`);
}
const rules = computed(() => {
  return {
    region: { required },
    district: { required },
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Edit Region - District";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
<style scoped></style>
